import {BBScripts as bbs}  from '../BBScripts';
import {BBElement}  from '../classes/forms/elements/BBElement';

var bbInit = function () {
    (window as any).BBScripts = new bbs();
    (window as any).BBElementClass = BBElement;
};

window.addEventListener('load', function () {
    bbInit();
}, false);
